import { render, staticRenderFns } from "./UcWorksheetEditorFieldset.yaml?vue&type=template&id=b02f8ab0&component"
import script from "./UcWorksheetEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports